module.exports = __webpack_public_path__ + "img/im_meal.190a5774.jpg";